import React from "react";
import { ScrollArea, Stack, Title } from "@mantine/core";

import { DeployNoteCreateCard } from "./DeployNoteCreateCard";
import { PublishReleaseCard } from "./PublishReleaseCard";
import { UnpublishedDeployNotesCard } from "../UnpublishedDeployNotesCard";

export const ReleaseNotesAdminPage: React.FC = () => {
  const [selected, setSelected] = React.useState<string[]>([]);

  return (
    <ScrollArea h="100%" w="100%" type="hover" offsetScrollbars>
      <Stack p="md" maw={{ base: "100%", lg: "50%" }} mx="auto">
        <Title order={2}>Release-notater</Title>
        <DeployNoteCreateCard />
        <UnpublishedDeployNotesCard onSelectionChange={(ids) => setSelected(ids)} />
        <PublishReleaseCard selectedDeployNoteIds={selected} onPublished={() => setSelected([])} />
      </Stack>
    </ScrollArea>
  );
};

export default ReleaseNotesAdminPage;
